/**
 * 상세 정산 「시간 상관없이 IN」 행 표시 — 서버가 준 최종 inOutType 과 inOutForcedBy 를 글자로만 바꾼다(판정하지 않는다).
 * 서버는 근무 시간으로는 OUT 인데 IN 으로 계산했을 때만 inOutForcedBy 를 싣는다. 없으면 지금 표시 그대로.
 */
export type InOutForcedBy = 'noshow' | 'exceptionRule';

/** 강제 IN 이유의 짧은 이름 — 노쇼 IN 설정 「노쇼」, 「항상 IN 요율의 배수」 예외 「예외」. 모르는 값·없음이면 null. */
export const inOutForcedLabel = (forcedBy: unknown): string | null =>
    forcedBy === 'noshow' ? '노쇼' : forcedBy === 'exceptionRule' ? '예외' : null;

/** 수업별 엑셀 IN/OUT 칸 — 「IN」·「OUT」, 강제 IN 이면 「IN(노쇼)」·「IN(예외)」. */
export const formatInOutCellText = (row: { inOutType?: unknown; inOutForcedBy?: unknown }): string => {
    if (row.inOutType !== 'IN') return 'OUT';
    const label = inOutForcedLabel(row.inOutForcedBy);
    return label ? `IN(${label})` : 'IN';
};

/** 그룹 세션의 회원 줄 상태 — 「노쇼」 → 노쇼로 IN 이면 「노쇼·IN」. */
export const withGroupForcedIn = (statusText: string, member: { inOutForcedBy?: unknown }): string =>
    member.inOutForcedBy === 'noshow' ? `${statusText}·IN` : statusText;

/**
 * 강제 IN 행의 마우스 올림 설명 — 무엇이 IN 으로 바뀌었는지(칸)와 금액이 무엇으로 정해졌는지(서버 appliedRule)를 나눠 말한다.
 * 노쇼 IN 은 칸만 바꾼다: 개별 요율·고정 금액·요율(%) 예외 수업은 금액이 그대로다(서버 계약 §6-2).
 *  - 개별 요율(appliedRule 'custom' 또는 그룹 회원의 개별 요율): 「IN 으로 분류했어요. 금액은 수강권 개별 요율이에요.」
 *  - 「항상 IN 요율의 배수」 예외(exceptionMode 'inMultiplier'): 「IN 요율에 배수를 곱했어요.」
 *  - 구간표(appliedRule 'tier', 그룹 기본): 「IN 요율로 계산했어요.」
 *  - 그 밖의 예외(고정·요율·배수): 「IN 으로 분류했어요. 금액은 예외 수업료 규칙대로예요.」
 */
export const forcedInTooltip = ({
    forcedBy,
    appliedRule,
    exceptionMode,
    isCustom,
    zeroRate,
}: {
    forcedBy: unknown;
    appliedRule?: unknown;
    exceptionMode?: unknown;
    isCustom?: boolean;
    zeroRate?: boolean;
}): string => {
    const reason = forcedBy === 'exceptionRule' ? '「항상 IN 요율의 배수」 예외라서' : '노쇼라서';
    let amount: string;
    if (isCustom || appliedRule === 'custom') amount = 'IN 으로 분류했어요. 금액은 수강권 개별 요율이에요.';
    else if (exceptionMode === 'inMultiplier') amount = 'IN 요율에 배수를 곱했어요.';
    else if (appliedRule === undefined || appliedRule === null || appliedRule === 'tier') amount = 'IN 요율로 계산했어요.';
    else amount = 'IN 으로 분류했어요. 금액은 예외 수업료 규칙대로예요.';
    return `${reason} 근무 시간과 상관없이 ${amount}${zeroRate ? ' IN 요율이 0이라 0원이에요.' : ''}`;
};
